import React, { Component } from 'react'
import PropTypes from 'prop-types'
import FlatButton from 'material-ui/FlatButton'
import { EditorState } from 'draft-js'
import { injectColorBlockFromNamedTemplate, insertColorBlock } from './modifiers'

const styles = {
  button: {
    position: 'relative',
    overflow: 'visible',
  },
  tooltip: {
    fontSize: '1.4rem',
    opacity: 0.95,
    top: '35px',
    width: '200px',
    height: 'auto',
    borderRadius: '10px',
    backgroundColor: 'dimgray',
    padding: '5px',
    position: 'absolute',
    zIndex: 2,
    color: 'white',
  },
}

class AddColorBlockButton extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isTooltipActive: false,
    }
  }

  activateTooltip = () => { this.setState({ isTooltipActive: true }) }
  inactivateTooltip = () => { this.setState({ isTooltipActive: false }) }

  injectColorBlock = () => {
    const nextContentState = injectColorBlockFromNamedTemplate(
      this.props.colorBlockType,
      this.props.editorState.getCurrentContent(),
      this.props.editorState.getSelection(),
    )

    const newEditorState = EditorState.set(
      this.props.editorState,
      { currentContent: nextContentState },
    )

    this.props.updateParentBodyState(newEditorState)
  }

  insertColorBlockFromModifier = () => {
    const blockStyles = {
      width: '600px',
      height: 'auto',
      backgroundColor: 'lightgrey',
      boxSizing: 'border-box',
    }

    const newEditorState = insertColorBlock(
      this.props.editorState,
      'Type text here...',
      blockStyles,
    )

    this.props.updateParentBodyState(newEditorState)
  }

  _renderTooltip = () => (
    <div className="tooltip" style={styles.tooltip}>
      <span>{this.props.tooltipText}</span>
    </div>
  )

  render() {
    const { labelText } = this.props
    return (
      <FlatButton
        label={labelText}
        onClick={this.insertColorBlockFromModifier}
        style={styles.button}
      />
    )
  }
}


AddColorBlockButton.propTypes = {
  editorState: PropTypes.instanceOf(EditorState).isRequired,
  updateParentBodyState: PropTypes.func.isRequired,
  colorBlockType: PropTypes.oneOf(['header', 'footer']).isRequired,
  labelText: PropTypes.string.isRequired,
  tooltipText: PropTypes.string.isRequired,
}

export default AddColorBlockButton



// WEBPACK FOOTER //
// ./src/components/sitewide/RichTextEditor/ColorBlock/AddColorBlockButton.js